<form
  class="flex flex-col gap-4 mt-10"
  [formGroup]="form"
  (ngSubmit)="onSubmit()">
  <div class="w-full h-[calc(100vh-185px)] flex flex-col gap-4">
    <div class="flex flex-col gap-4 justify-between">
      <qaroni-back-button
        text="Restablecer contraseña"
        class="ml-2"
        (back)="changeViewInfo()" />

      <div class="w-full flex flex-col gap-5 ml-2">
        <div class="w-full text-start flex flex-col justify-center gap-4 mt-4">
          <div class="flex flex-col text-start gap-2">
            <mat-form-field class="w-full" appearance="outline">
              <mat-label>Nueva contraseña</mat-label>
              <input
                matInput
                formControlName="password"
                [type]="hide ? 'password' : 'text'"
                required />
              <button
                type="button"
                mat-icon-button
                matSuffix
                (click)="changeVisibility()"
                [attr.aria-label]="'Hide password'">
                <mat-icon class="text-gray-700">{{
                  hide ? 'visibility_off' : 'visibility'
                }}</mat-icon>
              </button>
            </mat-form-field>

            @if (checkInputErrors(password)) {
              <qaroni-input-error-message matError [errors]="password.errors" />
            }
          </div>

          <div class="flex flex-col text-start gap-2">
            <mat-form-field class="w-full" appearance="outline">
              <mat-label>Confirmar contraseña</mat-label>
              <input
                matInput
                formControlName="confirmPassword"
                [type]="hideConfirm ? 'password' : 'text'"
                required />
              <button
                type="button"
                mat-icon-button
                matSuffix
                (click)="changeVisibilityConfirm()"
                [attr.aria-label]="'Hide password'">
                <mat-icon class="text-gray-700">{{
                  hideConfirm ? 'visibility_off' : 'visibility'
                }}</mat-icon>
              </button>
            </mat-form-field>

            @if (checkInputErrors(confirmPassword)) {
              <qaroni-input-error-message
                matError
                [errors]="confirmPassword.errors" />
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="w-full mx-auto text-center flex gap-3 justify-center">
    <button
      (click)="changeViewInfo()"
      class="min-w-[80px] md:min-w-[110px] text-qaroni-text-primary text-base leading-6 font-semibold">
      Cancelar
    </button>

    <button
      mat-flat-button
      class="!min-w-[80px] md:!min-w-[110px] !px-5 !py-3 !text-base !font-normal !tracking-normal !rounded-full !h-[45px]"
      color="primary"
      [isLoading]="submitting"
      qaroniLoadButton
      type="submit"
      [disabled]="!validatedForm">
      Guardar
    </button>
  </div>
</form>
